import { ILocationItemResponse } from "../../services/edit-hospital-location/edit-hospital-location.interface";
import { actionTypes } from "./updateLocation.action";

export interface IUpdateLocationState {
  locationSelected: ILocationItemResponse[];
};

const initialState : IUpdateLocationState = {
  locationSelected: [],
};

export const updateLocationReducer = (
  state: IUpdateLocationState = initialState,
  action: { type: string, payload: any },
)=>{
  switch (action.type) {
  case actionTypes.SET_LOCATION_SELECTED:
    return {
      ...state,
      locationSelected: action.payload,
    };
  default: {
    return state;
  }
  }
};
